import styled from 'styled-components';

export const UiClickablePopoverMenu = styled.div`
	display: flex;
	border-radius: 50%;
	transition: 0.35s;

	& > svg {
		cursor: pointer;
	}

	&:hover {
		background-color: #fafafc;
	}
`;